<template>
    <div>
        <va-card v-if="pag == true" class="flex xs12 sm12 lg12" >
          <div class="mb-3"><div class="va-notification" style="background: rgba(64, 229, 131, 0.2); box-shadow: rgba(64, 229, 131, 0.4) 0px 0.125rem 0.125rem 0px;"><div class="va-notification__content">
            Transacion non realizada!
          </div><div class="va-notification__close-icon"><i class="va-icon ion-md-close ion"  style="color: rgb(64, 229, 131);"></i></div></div></div>
     
        </va-card>

        <va-card v-if="pag == false" class="flex xs12 sm12 lg12" >
          <div class="mb-3"><div class="va-notification" style="background: rgba(64, 229, 131, 0.2); box-shadow: rgba(64, 229, 131, 0.4) 0px 0.125rem 0.125rem 0px;"><div class="va-notification__content">
            Transacion non realizada!
          </div><div class="va-notification__close-icon"><i class="va-icon ion-md-close ion"  style="color: rgb(64, 229, 131);"></i></div></div></div>
     
        </va-card>
  
  </div>

</template>

<script>

import axios from 'axios';
export default {
    name:'confirm',

    data () {
        return {
           
     
        }

    },

    created(){
      var url_string = window.location.href;
      //var url = new URL(url_string);
      var parametrosDaUrl = url_string.split("?")[1]; // id=10&name=gustavo
      var listaDeParametros = parametrosDaUrl.split("=") 
    
      let resultado = url_string.split("=")
      console.log(resultado[1])
      let pag = resultado[1]

      if(pag == "payment_fail"){
            alert(pag)
      }
    },

   
    methods:{

      pegar_parametros(){


      },

    }
    
}
</script>

<style lang="scss" scoped>



</style>